<template>
  <b-modal
    :id="id"
    :ref="id"
    :ok-only="true"
    ok-title="ปิด"
    title="รายการโครงการที่รอปิด"
    size="xl"
    @hide="onClose"
  >
    <template v-if="IS_LOADING">
      <loading-spinner />
    </template>

    <template v-else>
      <table class="table table-borderless">
        <tr>
          <th class="text-right" width="250">จำนวนโครงการรอปิด</th>
          <td>{{ previousProjects.length }} โครงการ</td>
        </tr>
      </table>
    </template>
    <b-list-group v-for="(proj, index) in previousProjects" :key="index" class="previousProject" :class="proj.statusClass">
      <b-list-group-item class="project-bar">
        <div class="meta">
          <span class="status-badge">{{ proj.statusText }}</span>
          <router-link :to="{ name: 'projects.show.proposal.basic', params: { id: proj.id } }" target="_blank" class="text-item mr-5"><h5 class="my-1">{{ index+1 }}. {{ proj.name }}</h5></router-link>
          <span class="group">ประธานโครงการ: <strong>{{ proj.author.thFullName }}</strong></span>
          <span class="group">ที่ปรึกษาโครงการ: <strong>{{ proj.advisor.name }}</strong></span>
        </div>
      </b-list-group-item>
    </b-list-group>
  </b-modal>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'
import LoadingSpinner from '@/components/layouts/LoadingSpinner'

export default {
  components: {
    LoadingSpinner
  },
  props: {
    id: { type: String, required: true },
    projectId: { type: String, default: null }
  },
  data: () => ({
    IS_LOADING: false,
    previousProjects: []
  }),
  apollo: {
    previousProjects: {
      query: gql`
        query previousProjects($id: ID!) {
          projectCheckIssuringPreconditionCheck(id: $id) {
            id name statusText statusClass
            group { name }
            author { thFullName }
            advisor { name }
          }
        }`,
      fetchPolicy: 'no-cache',
      variables () {
        return { id: this.projectId }
      },
      update (data) {
        this.IS_LOADING = false
        return data.projectCheckIssuringPreconditionCheck
      },
      skip () {
        this.IS_LOADING = true
        return !this.projectId
      }
    }
  },
  computed: {
    project () { return this.$store.getters['checking/getCheckingById'](this.projectId) }
  },
  watch: {
    projectId (newId) {
      if (!newId) { return }
      // this.form.payee = this.project.advisor.name
      this.$refs[this.id].show()
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).add(7, 'hours').format('D/M/Y')
    },
    onClose (event) {
      this.$nextTick(() => { this.$refs[this.id].hide() })
      this.form = { no: '', payee: '' }
      this.previousProjects = []
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="scss">
.previousProject{
  .project-bar{
    &:hover {
    background: $gray-100;
    }
    .status-badge{
      font-weight: $font-weight-bold;
       font-size: $font-size-base * 0.85;
    }
}
  .meta {
    font-size: $font-size-sm;
    color: $gray-600;
    font-weight: $font-weight-normal;
    .group {
        margin-right: 30px;
      }
    }
  .text-item{
    &:hover{
      text-decoration: none;
    };
  }
   @mixin status-class($status, $status-color) {
    &.#{$status} {
      .project-bar {
      border-left-color: $status-color !important;
      border-left-width: 2px;
      .status-badge {
        background-color: $status-color;
        }
      }
    }
  }
  @include status-class('awaiting', $awaiting-status-color);
  @include status-class('approved', $approved-status-color);
  }
 </style>
